'use client';
import React, { FC } from 'react';
import detailStyles from './detail.module.scss';
// import cls from 'classnames';
import type { SocialMedia } from '@/apis';

enum MediaType {
  Blog = 1,
  Forum = 2,
  NewsLetter = 3,
  Telegram = 4,
  Twitter = 5,
  Facebook = 6,
  Instagram = 7,
  Youtube = 8,
  Medium = 9,
  Discord = 10,
  Reddit = 11,
  LinkedIn = 12,
  Quora = 13,
  Github = 14,
  Wechat = 15,
}

const mediaIconMap = {
  [MediaType.Facebook]:
    '/common-static/fhs/facebook-fd2e2af0ee9b57bce0d0e24383e95926.svg',
  [MediaType.Telegram]:
    '/common-static/fhs/telegram-1913be94bcf6b98848c2563883cf529f.svg',
  [MediaType.Twitter]:
    '/common-static/fhs/twitter-5d633a3ef8b9db3905aa0df4d6af0266.svg',
  [MediaType.Instagram]:
    '/common-static/fhs/ins-a84c8a13d1ac4795cafe97acc61ab5a2.svg',
  [MediaType.Youtube]:
    '/common-static/fhs/youtube-04e64eaaa87883b331929da7033c0706.svg',
  [MediaType.Reddit]:
    '/common-static/fhs/reddit-7423e0e9a5da43df21b749184700ffaf.svg',
  [MediaType.Blog]:
    '/common-static/fhs/Blog-05bde8b172cbe6df6ef5a3a29f94b2fe.svg',
  [MediaType.Forum]:
    '/common-static/fhs/icon-forum-963087fec8b5badfa162e0e35bbcbcac.svg',
  [MediaType.NewsLetter]:
    '/common-static/fhs/icon-news-419acbeb0901f44b0b8c2b086bc2f1b6.svg',
  [MediaType.Medium]:
    '/common-static/fhs/icon-medium-83fa877f01db21b2a7b46907f1d71ab2.svg',
  [MediaType.Discord]:
    '/common-static/fhs/icon-discord-eaabaf6904ce3fbef9af4651d850635d.svg',
  [MediaType.LinkedIn]:
    '/common-static/fhs/icon-linkedIn-f8278cb0d3828cf5a5d6594f3f4c422f.svg',
  [MediaType.Quora]:
    '/common-static/fhs/icon-quora-7bd1fca67da1caf155d919fbd9234059.svg',
  [MediaType.Github]:
    '/common-static/fhs/icon-github-9331fbe7f938666dd7325f423f50b9a6.svg',
  [MediaType.Wechat]:
    '/common-static/fhs/icon-wechat-697e797ecdb37aefdea07da6b9f95309.svg',
};

export interface Props {
  media: SocialMedia[];
  onAction?: (media: SocialMedia) => void;
}

export const Media: FC<Props> = ({ media, onAction }) => {
  const mediaNodes =
    media && media.length > 0
      ? media.map((item) => {
          const imageUrl =
            mediaIconMap[item.mediaType] || mediaIconMap[MediaType.Facebook];
          const handleAction = () => {
            onAction?.(item);
          };
          return (
            <img
              className={detailStyles.item}
              key={item.mediaType}
              src={imageUrl}
              onClick={handleAction}
              alt=""
            />
          );
        })
      : null;

  return <div className={detailStyles.media}>{mediaNodes}</div>;
};
